import MessageInput from "@/components/message/message-input";
import ExampleQuestion from "@/components/ai/example-question-list";

const MessageBox = ({
  onSend,
}: {
  onSend: (text: string, files?: File[]) => void;
}) => {
  return (
    <div className="flex flex-col gap-4">
      <MessageInput onSend={onSend} isHome={true} chatId="temp" />
      <ExampleQuestion />
    </div>
  );
};

export default MessageBox;
